/* MyTomette — sélecteur de modèles en images (30/09/2026).
   Monte dans l'écran #sInsp de l'atelier expert et remplace le carrousel dessiné
   en direct. Les modèles, catégories et prix viennent du moteur (__MT_CORE__) ;
   les images viennent d'un manifeste (mt-selecteur.json) et d'OVH. Un modèle sans
   image enregistrée (publié depuis) est dessiné sur place par le moteur. */
(function(){
  'use strict';
  var CFG = window.MT_SELECTEUR || {};
  if (!CFG.actif) return;
  var EN = /^en/i.test(document.documentElement.lang || '');
  var T = EN ? {
    titre:'Choose <em>your</em> design', tous:'All', selection:'Workshop picks', chercher:'A name, a theme…', chercherAria:'Search a design',
    tout:'All', tomettes:'Hexagons', carreaux:'Squares', aPartir:'From ', go:'Personalise this design', goCourt:'Personalise',
    blanche:'or start from a blank tile', vide:'No design matches. Try another word.', sansPhoto:'Photos coming soon',
    prec:'Previous design', suiv:'Next design', catPrec:'Previous categories', catSuiv:'More categories', photo:'See photo ',
    fermerPhoto:'Close photo', photoPrec:'Previous photo', photoSuiv:'Next photo',
    fmt:{hexa:'Hexagon 12 × 10 cm', carree:'Square 13 × 13 cm'},
    photoNom:'Your photo, engraved', photoFil:'Photo tile', photoCat:'Your photo', photoAria:'Photo tile: your photo, engraved',
    photoGo:'Choose my photo', photoGoCourt:'My photo', ouverture:'Opening…',
    vigEpreuve:'See the example photo', vigGravure:'See the engraved tile',
    photoMots:'photo picture portrait photo booth memory keepsake couple family wedding',
    carteNom:'Your place, engraved', carteFil:'Engraved map', carteCat:'A place', carteAria:'Engraved map: your place, engraved in terracotta',
    carteGo:'Choose my place', carteGoCourt:'My place', carteIndispo:'The engraved map is temporarily unavailable. Please try again in a moment.',
    vigPlan:'See the example map', vigCarreau:'See the engraved square tile',
    carteMots:'map plan place address gps coordinates where we met couple anniversary wedding travel trip home house city neighbourhood memory keepsake',
    cielNom:'The sky of the night you met', cielFil:'Star map', cielAria:'Engraved star map: the sky of the night you met, on terracotta',
    cielGo:'Choose my sky', cielGoCourt:'My sky', cielIndispo:'The star map is temporarily unavailable. Please try again in a moment.',
    vigCiel:'See the example sky',
    cielMots:'sky stars starry star constellation constellations night moon astronomy astro star map sky map celestial birth meeting met wedding anniversary couple memory keepsake'
  } : {
    titre:'Choisissez <em>votre</em> modèle', tous:'Tous', selection:'Sélection de l’atelier', chercher:'Un prénom, un thème…', chercherAria:'Rechercher un modèle',
    tout:'Tout', tomettes:'Tomettes', carreaux:'Carreaux', aPartir:'À partir de ', go:'Personnaliser ce modèle', goCourt:'Personnaliser',
    blanche:'ou partir d’une page blanche', vide:'Aucun modèle ne correspond. Essayez un autre mot.', sansPhoto:'Photos bientôt disponibles',
    prec:'Modèle précédent', suiv:'Modèle suivant', catPrec:'Catégories précédentes', catSuiv:'Autres catégories', photo:'Voir la photo ',
    fermerPhoto:'Fermer la photo', photoPrec:'Photo précédente', photoSuiv:'Photo suivante',
    fmt:{hexa:'Tomette 12 × 10 cm', carree:'Carreau 13 × 13 cm'},
    photoNom:'Votre photo, gravée', photoFil:'Tomette photo', photoCat:'Votre photo', photoAria:'Tomette photo : votre photo, gravée',
    photoGo:'Choisir ma photo', photoGoCourt:'Ma photo', ouverture:'Ouverture…',
    vigEpreuve:'Voir la photo d’exemple', vigGravure:'Voir la tomette gravée',
    photoMots:'photo portrait photomaton souvenir couple famille mariage',
    carteNom:'Votre lieu, gravé', carteFil:'Carte gravée', carteCat:'Un lieu', carteAria:'Carte gravée : votre lieu, gravé sur terre cuite',
    carteGo:'Choisir mon lieu', carteGoCourt:'Mon lieu', carteIndispo:'La carte gravée est momentanément indisponible. Réessayez dans un instant.',
    vigPlan:'Voir le plan d’exemple', vigCarreau:'Voir le carreau gravé',
    carteMots:'carte plan lieu adresse gps coordonnées rencontre couple anniversaire mariage voyage maison ville quartier souvenir map',
    cielNom:'Le ciel de votre rencontre', cielFil:'Carte du ciel', cielAria:'Carte du ciel gravée : le ciel de votre rencontre, gravé sur terre cuite',
    cielGo:'Choisir mon ciel', cielGoCourt:'Mon ciel', cielIndispo:'La carte du ciel est momentanément indisponible. Réessayez dans un instant.',
    vigCiel:'Voir le ciel d’exemple',
    /* cahier ciel §4.1 : la liste de recherche, FR puis EN */
    cielMots:'ciel étoiles étoilé constellation constellations nuit lune astronomie astro carte du ciel naissance rencontre mariage anniversaire couple star map sky stars night moon'
  };
  var reduit = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SVG = {
    g:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="m15 5-7 7 7 7"/></svg>',
    d:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="m9 5 7 7-7 7"/></svg>',
    x:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    fl:'<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M5 12h14m-6-6 6 6-6 6"/></svg>',
    loupe:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="11" cy="11" r="6.5"/><path d="m16 16 4.5 4.5"/></svg>',
    hexa:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 3.5h10L22 12l-5 8.5H7L2 12z"/></svg>',
    carre:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3.5" y="3.5" width="17" height="17" rx="2"/></svg>',
    photo:'<svg class="mts-cat-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 8.5h3.2l1.7-2.6h7.2l1.7 2.6h3.2v10.6H3.5z"/><circle cx="12" cy="13.6" r="3.3"/></svg>',
    /* l'épingle de l'outil GPS (lieu.js, EPINGLE) : la pastille « Un lieu » parle la même langue */
    lieu:'<svg class="mts-cat-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" aria-hidden="true"><path d="M12 21.5s-6.5-5.4-6.5-10.3A6.5 6.5 0 0112 4.7a6.5 6.5 0 016.5 6.5c0 4.9-6.5 10.3-6.5 10.3z"/><circle cx="12" cy="11.2" r="2.2"/></svg>'
  };
  function norm(s){ return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' }[c]; }); }

  /* ---------- attendre le moteur et le vrai catalogue ----------
     Le moteur démarre avec 8 modèles de secours, puis reçoit le catalogue d'OVH. */
  var essais = 0, MANIF = null;
  function pret(){
    var C = window.__MT_CORE__, ins = document.getElementById('sInsp');
    if (!C || !ins || !C.TEMPLATES) return false;
    var reels = C.TEMPLATES.some(function(t){ return /^tpl_/.test(t.id); });
    return reels || essais > 60;
  }
  function attendre(){
    if (pret()) { demarrer(); return; }
    essais++; setTimeout(attendre, 200);
  }
  function lire(u){ return u ? fetch(u, { credentials:'omit', cache:'no-cache' }).then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; }) : Promise.resolve(null); }
  lire(CFG.manifeste).then(function(m){ return (m && m.mods) ? m : lire(CFG.secours); })
    .then(function(m){ MANIF = (m && m.mods) ? m : { mods:{}, selection:[] }; attendre(); });

  function demarrer(){
    var C = window.__MT_CORE__, ins = document.getElementById('sInsp');
    var BASE = CFG.images.replace(/\/?$/, '/');
    var PRIX = {}; Object.keys(C.SHAPES || {}).forEach(function(k){ PRIX[k] = +C.SHAPES[k].price || 0; });
    var NOMS = {}; (C.OCCASIONS || []).forEach(function(o){ NOMS[o[0]] = o[1]; });
    var root = document.createElement('div'); root.className = 'mts';
    root.innerHTML =
      '<div class="mts-tete"><h2 class="mts-titre">' + T.titre + '</h2><div class="mts-outils">' +
        '<label class="mts-cherche">' + SVG.loupe + '<input type="search" placeholder="' + T.chercher + '" aria-label="' + T.chercherAria + '" autocomplete="off"></label>' +
      '</div></div>' +
      '<div class="mts-ruban-cadre"><nav class="mts-ruban" aria-label="Catégories"><div class="mts-ligne"></div><div class="mts-ligne"></div></nav>' +
        '<button class="mts-rfl mts-rg" type="button" aria-label="' + T.catPrec + '"><span>' + SVG.g + '</span></button>' +
        '<button class="mts-rfl mts-rd" type="button" aria-label="' + T.catSuiv + '"><span>' + SVG.d + '</span></button></div>' +
      '<section class="mts-scene" aria-roledescription="carrousel" aria-label="Modèles"><div class="mts-lumiere"></div><div class="mts-socle"></div>' +
        '<button class="mts-fleche mts-fg" type="button" aria-label="' + T.prec + '">' + SVG.g + '</button>' +
        '<button class="mts-fleche mts-fd" type="button" aria-label="' + T.suiv + '">' + SVG.d + '</button>' +
        '<button class="mts-gosc" type="button">' + T.goCourt + ' ' + SVG.fl + '</button>' +
        '<div class="mts-compteur"><span class="mts-num">1</span><div class="mts-barre"><i></i></div><span class="mts-tot">1</span></div></section>' +
      '<p class="mts-vide" hidden>' + T.vide + '</p>' +
      '<article class="mts-fiche" aria-live="polite"><div class="mts-vignettes"></div>' +
        '<div class="mts-infos"><button type="button" class="mts-fil"></button><h3 class="mts-nom"></h3><div class="mts-puces"></div><p class="mts-note" hidden></p></div>' +
        '<div class="mts-agir"><button class="mts-go" type="button">' + T.go + ' ' + SVG.fl + '</button><button class="mts-blanche" type="button">' + T.blanche + '</button></div></article>' +
      '<div class="mts-loupe" aria-hidden="true"><div class="mts-grand"></div>' +
        '<button class="mts-nav mts-g" type="button" aria-label="' + T.photoPrec + '">' + SVG.g + '</button>' +
        '<button class="mts-nav mts-d" type="button" aria-label="' + T.photoSuiv + '">' + SVG.d + '</button>' +
        '<button class="mts-rond" type="button" aria-label="' + T.fermerPhoto + '">' + SVG.x + '</button></div>';
    ins.appendChild(root); ins.classList.add('mts-on');
    var $ = function(s){ return root.querySelector(s); };

    /* ---------- les modèles : ceux du moteur, dans son ordre ---------- */
    var mods = C.TEMPLATES.filter(function(t){ return t && t.els && t.els.length; }).map(function(t){
      var e = MANIF.mods[t.id] || {};
      return { id:t.id, n:t.name, c:t.occ, f:t.shape === 'carree' ? 'carree' : 'hexa', sh:(t.allowShapes || [t.shape]),
        t:e.c ? BASE + e.c : null, v:e.v ? BASE + e.v : null, s:e.s ? BASE + e.s : null, sn:e.sn || 0, tpl:t };
    });

    /* ---------- la tomette photo (14/10/2026) ----------
       Une carte vedette, en tête de « Tous » : la tuile gravée du couple, avec l'épreuve
       photo dont elle est tirée. Elle n'existe que si la page déclare MT_PHOTO_EXPERT_CFG
       (snippet mt-photo-expert, absent quand le produit photo n'est pas vendable) : c'est
       l'interrupteur, et sans lui le carrousel est celui d'avant. Ses prix viennent de cette
       déclaration, jamais de PRIX, qui donne ceux de la tomette classique. */
    /* Contexte inerte (même test que inerte() de photo-commun.js, fait ici sans attendre le module,
       qui n'est peut-être pas encore chargé) : admin (?admin=1), lien partagé (mtv=) ou création
       client (mtc=) dans le fragment d'origine, moteur de la fiche photo. Aucune entrée photo. */
    var PH_INERTE = (function(){
      try {
        var s0 = window.__MT_CORE__ && window.__MT_CORE__.state, h0 = String(window.__MTW_HASH_INITIAL__ || location.hash || '');
        if (s0 && s0.photoProduct) return true;
        if (/[?&]admin=1/.test(location.search) || /[#&]mt[vc]=/.test(h0)) return true;
        try { if (window.frameElement && window.frameElement.classList.contains('mt-photo-engine')) return true; } catch (e) {}
      } catch (e) {}
      return false;
    })();
    var PH = window.MT_PHOTO_EXPERT_CFG, VED = !PH_INERTE && PH && PH.actif && PH.vedette, PHOTO = null;
    if (VED && VED.c && PH.prix && PH.prix['hexa|0'] != null) {
      PHOTO = { id:'mt-photo', n:T.photoNom, c:'mt-photo', f:'hexa', sh:['hexa', 'carree'],
        t:VED.c, v:VED.v || VED.c, pm:VED.pm || null, ph:[VED.pm, VED.c].concat(VED.photos || []).filter(Boolean).slice(0, 5),
        prix:{ hexa:+PH.prix['hexa|0'], carree:PH.prix['carree|0'] != null ? +PH.prix['carree|0'] : 0 }, photo:true, duo:!!VED.pm,
        mots:T.photoMots };
      mods.unshift(PHOTO);
      NOMS['mt-photo'] = T.photoFil;
    }

    /* ---------- la carte gravée (15/10/2026, cahier carte §4.1) ----------
       Une seconde carte vedette, juste après la photo : la tomette gravée du Vieux-Port et le plan
       papier dont elle est tirée (même paire inclinée que la photo). Elle n'existe que si la page
       déclare MT_CARTE_EXPERT_CFG avec actif et vedette (snippet mt-carte-expert, interrupteur
       mtcx_actif) : sans elle, le carrousel est celui d'avant. Mêmes contextes inertes que la
       photo, plus le moteur caché de la fiche carte (iframe .mt-carte-engine). PAS de prix propres :
       une carte coûte une tomette classique (D1), la fiche lit donc PRIX. tC / vC = la gravure
       carreau, montrée à la place de la tomette quand le filtre de forme vaut « carree ». */
    var CA_INERTE = PH_INERTE || (function(){ try { return !!(window.frameElement && window.frameElement.classList.contains('mt-carte-engine')); } catch (e) { return false; } })();
    var CA = window.MT_CARTE_EXPERT_CFG, VCA = !CA_INERTE && CA && CA.actif && CA.vedette, CARTE = null;
    if (VCA && VCA.c) {
      CARTE = { id:'mt-carte', n:T.carteNom, c:'mt-carte', f:'hexa', sh:['hexa', 'carree'],
        t:VCA.c, v:VCA.v || VCA.c, pm:VCA.pm || null, tC:VCA.cCarree || null, vC:VCA.vCarree || VCA.cCarree || null,
        ph:[VCA.pm, VCA.c, VCA.cCarree].concat(VCA.photos || []).filter(Boolean).slice(0, 6),
        carte:true, duo:!!VCA.pm, mots:T.carteMots };
      mods.splice(PHOTO ? 1 : 0, 0, CARTE);
      NOMS['mt-carte'] = T.carteFil;
    }
    /* ---------- la carte du ciel (15/10/2026, cahier ciel §4.1) ----------
       Une troisième carte vedette, juste après la carte gravée : le médaillon du ciel du Vieux-Port
       (14.02.2025, 22 h 00) et l'épreuve « ciel imprimé » dont il est tiré (même paire inclinée).
       Elle n'existe que si la page déclare MT_CIEL_EXPERT_CFG avec actif et vedette (snippet
       mt-ciel-expert, interrupteur mtci_actif) : sans elle, le carrousel est celui de la carte.
       Mêmes contextes inertes que la carte, plus le moteur caché de la fiche ciel (iframe
       .mt-ciel-engine). PAS de prix propres : un ciel coûte une tomette classique (K2), la fiche lit
       PRIX. tC / vC = le médaillon sur carreau, montré quand le filtre de forme vaut « carree ». Pas de
       pastille à elle : elle vit dans « Un lieu », après la carte (K24). */
    var CI_INERTE = CA_INERTE || (function(){ try { return !!(window.frameElement && window.frameElement.classList.contains('mt-ciel-engine')); } catch (e) { return false; } })();
    var CI = window.MT_CIEL_EXPERT_CFG, VCI = !CI_INERTE && CI && CI.actif && CI.vedette, CIEL = null;
    if (VCI && VCI.c) {
      CIEL = { id:'mt-ciel', n:T.cielNom, c:'mt-ciel', f:'hexa', sh:['hexa', 'carree'],
        t:VCI.c, v:VCI.v || VCI.c, pm:VCI.pm || null, tC:VCI.cCarree || null, vC:VCI.vCarree || VCI.cCarree || null,
        ph:[VCI.pm, VCI.c, VCI.cCarree].concat(VCI.photos || []).filter(Boolean).slice(0, 6),
        ciel:true, duo:!!VCI.pm, mots:T.cielMots };
      mods.splice((PHOTO ? 1 : 0) + (CARTE ? 1 : 0), 0, CIEL);   /* 3ᵉ position de « Tous » */
      NOMS['mt-ciel'] = T.cielFil;
    }
    /* la pastille « Un lieu » montre la vedette, puis les modèles de la catégorie voyage du
       catalogue s'il y en a une (son identifiant contient « voyage ») ; sinon la vedette seule.
       15/10 (ciel) : la vedette carte, puis la vedette ciel, puis les modèles voyage ; la pastille
       existe dès que l'une des deux vedettes est là (son identifiant reste « mt-carte ») */
    var VOYAGE = null;
    if (CARTE || CIEL) (C.OCCASIONS || []).some(function(o){ if (o[0] !== 'all' && /voyage/i.test(o[0]) && mods.some(function(m){ return m.c === o[0]; })) { VOYAGE = o[0]; return true; } return false; });
    var etat = { cat:'tous', forme:'tout', q:'' };
    /* la vue d'un modèle selon le filtre de forme : seule une entrée qui porte sa gravure carreau
       (tC, la carte) change d'image ; pour toutes les autres, c'est m.t / m.v et m.f, comme avant */
    function enCarre(m){ return !!(m.tC && etat.forme === 'carree'); }
    function formeVue(m){ return enCarre(m) ? 'carree' : m.f; }
    function tuile(m, net){ return enCarre(m) ? (net ? m.tC : (m.vC || m.tC)) : (net ? m.t : (m.v || m.t)); }
    var liste = [], cartes = [], pos = 0, courant = null;

    /* un modèle publié après la génération des images : le moteur le dessine ici même */
    /* 14/10 : la plupart des modèles portent leur logo en svgRef (SVG propre au modèle, rangé sur
       OVH). Depuis le sélecteur en images, le moteur ne précharge plus ces SVG
       (ensureAllTemplateLogos) : renderPNG ne les trouvait pas et dessinait son motif de secours,
       la feuille. On va chercher chaque svgRef à la même adresse et avec les mêmes options que
       l'éditeur (cache HTTP partagé), puis on le passe EN LIGNE à une COPIE des éléments :
       m.tpl.els reste intact, la recette ne grossit pas. SVG introuvable : élément inchangé
       (comme avant), et nouvel essai au prochain passage. */
    var SVGREF = {}, URL_SVGREF = 'https://admin.mytomette.fr/save.php?public=template-asset&path=';
    function svgDuModele(ref){
      if (!SVGREF[ref]) SVGREF[ref] = fetch(URL_SVGREF + encodeURIComponent('template-assets/svg/' + ref + '.svg'), { cache:'force-cache' })
        .then(function(r){ return r.ok ? r.text() : ''; }).catch(function(){ return ''; })
        .then(function(s){ if (!/<svg[\s>]/i.test(s)) { delete SVGREF[ref]; return ''; } return s; });
      return SVGREF[ref];
    }
    function elsDessinables(els){
      var manque = false;
      return Promise.all((els || []).map(function(e){
        if (!e || e.type !== 'icon' || e.svg || !e.svgRef || !/^[\w-]{1,80}$/.test(e.svgRef)) return e;
        return svgDuModele(e.svgRef).then(function(s){
          if (!s) { manque = true; return e; }
          var c = {}; for (var k in e) if (Object.prototype.hasOwnProperty.call(e, k)) c[k] = e[k];
          c.svg = s; return c;
        });
      })).then(function(l){ return { els:l, complet:!manque }; });
    }
    var dessins = {};
    function imageDe(m, grande){
      if (m.t) return Promise.resolve(tuile(m, grande));
      if (!dessins[m.id]) dessins[m.id] = elsDessinables(m.tpl.els).then(function(d){
        return new Promise(function(ok){
          try { C.renderPNG({ shape:m.f, hole:false, els:d.els }, function(u){ ok(typeof u === 'string' ? u : null); }); } catch (e) { ok(null); }
        }).then(function(u){ if (!d.complet) delete dessins[m.id]; return u; });
      });
      return dessins[m.id];
    }

    /* ---------- filtres ---------- */
    function dansCat(m, c){ return c === 'tous' || m.c === c || (c === 'mt-carte' && (m.c === 'mt-ciel' || (!!VOYAGE && m.c === VOYAGE))); }
    /* forme : une entrée à deux formes n'est retenue par sh QUE si elle a de quoi montrer l'autre
       forme (tC) — la vedette photo, hexagone seul en image, reste hors de « Carrée » */
    function filtre(c){ return mods.filter(function(m){ return dansCat(m, c) && (etat.forme === 'tout' || m.f === etat.forme || (!!m.tC && (m.sh || []).indexOf(etat.forme) >= 0))
      && (!etat.q || norm(m.n + ' ' + (NOMS[m.c] || '') + ' ' + (m.mots || '')).indexOf(etat.q) >= 0); }); }
    var ruban = $('.mts-ruban'), lignes = root.querySelectorAll('.mts-ligne');
    /* 01/10 : noms courts pour tenir sur deux lignes ; la fiche les reprend */
    var COURT = EN ? {} : { valentin:'Amour', 'mots-doux':'Messages gravés', amitie:'Amis', provence:'Provence', maitresse:'Maîtresse',
      animaux:'Animaux', pro:'Entreprise', 'carreaux-decoratifs':'Carreaux déco' };
    Object.keys(COURT).forEach(function(k){ if (NOMS[k]) NOMS[k] = COURT[k]; });
    var cats = [{ id:'tous', n:T.tous }];
    /* la pastille de la tomette photo vient juste après « Tous », marquée comme une entrée à part */
    if (PHOTO) cats.push({ id:'mt-photo', n:T.photoCat, cls:' mts-etoile mts-cat-photo', ic:SVG.photo });
    /* puis celle de la carte gravée, de la même famille : une entrée, pas un compteur */
    if (CARTE || CIEL) cats.push({ id:'mt-carte', n:T.carteCat, cls:' mts-etoile mts-cat-carte', ic:SVG.lieu });   /* + le ciel (15/10) */
    (C.OCCASIONS || []).forEach(function(o){ if (o[0] !== 'all' && mods.some(function(m){ return m.c === o[0]; })) cats.push({ id:o[0], n:NOMS[o[0]] || o[1] }); });
    var poids = cats.map(function(c){ return c.n.length + 5; }), total = poids.reduce(function(a, b){ return a + b; }, 0), cumul = 0;
    cats.forEach(function(c, i){
      var b = document.createElement('button'); b.type = 'button'; b.className = 'mts-cat' + (c.cls || ''); b.dataset.c = c.id;
      b.innerHTML = (c.ic || '') + '<span></span><sup></sup>'; b.querySelector('span').textContent = c.n;
      b.addEventListener('click', function(){ if (c.id !== etat.cat) { etat.cat = c.id; majRuban(true); charger(); } });
      lignes[cumul + poids[i] / 2 <= total / 2 ? 0 : 1].appendChild(b); cumul += poids[i];
    });
    function majRuban(centrer){
      var qv = etat.q; etat.q = '';
      ruban.querySelectorAll('.mts-cat').forEach(function(b){ b.setAttribute('aria-pressed', String(b.dataset.c === etat.cat)); var n = filtre(b.dataset.c).length; b.querySelector('sup').textContent = n; b.hidden = n === 0 && b.dataset.c !== etat.cat; });
      etat.q = qv;
      var a = ruban.querySelector('.mts-cat[aria-pressed="true"]');
      if (a && a.offsetWidth && centrer) ruban.scrollTo({ left:a.offsetLeft - (ruban.clientWidth - a.offsetWidth) / 2 });
      fleches();
    }
    var rg = $('.mts-rg'), rd = $('.mts-rd');
    function fleches(){ var max = ruban.scrollWidth - ruban.clientWidth; rg.classList.toggle('mts-vue', ruban.scrollLeft > 4); rd.classList.toggle('mts-vue', ruban.scrollLeft < max - 4); }
    ruban.addEventListener('scroll', fleches, { passive:true });
    rg.addEventListener('click', function(){ ruban.scrollBy({ left:-ruban.clientWidth * .7 }); });
    rd.addEventListener('click', function(){ ruban.scrollBy({ left:ruban.clientWidth * .7 }); });
    function majForme(){}
    var q = $('.mts-cherche input'), cherche = $('.mts-cherche'), tq = 0;
    function chercher(v){ clearTimeout(tq); tq = setTimeout(function(){ etat.q = norm(String(v).trim()); charger(); }, 180); }
    q.addEventListener('input', function(){ chercher(q.value); });
    cherche.addEventListener('click', function(){ cherche.classList.add('mts-ouverte'); q.focus(); });
    q.addEventListener('blur', function(){ if (!q.value) cherche.classList.remove('mts-ouverte'); });

    /* ---------- préchargement : une avance de ±8 cartes, décodées du centre vers l'extérieur ---------- */
    var AVANCE = 8, EN_PARALLELE = 3, charges = {};
    function charge(src){
      if (!src) return Promise.resolve(null);
      if (!charges[src]) charges[src] = new Promise(function(ok){ var im = new Image(); im.decoding = 'async';
        im.onload = function(){ (im.decode ? im.decode().catch(function(){}) : Promise.resolve()).then(function(){ ok(src); }); };
        im.onerror = function(){ ok(null); }; im.src = src; });
      return charges[src];
    }
    /* LE PREMIER ÉCRAN D'ABORD (14/10). attente.js garde son voile tant que la tomette du centre
       n'est pas décodée : tout ce qui se télécharge en même temps la retarde. Tant que ce n'est
       pas fait (« ouvert » faux), seul le centre a droit à son image nette ; les voisines prennent
       la petite, et l'épreuve de la carte photo, les images nettes des premières voisines et les
       vignettes de la fiche photo attendent leur tour (affiner()). Le client ne voit rien de
       cette attente : elle se passe sous le voile. */
    var ouvert = false, apres = [];
    var file = [], actives = 0, generation = 0;
    function planifier(){
      var g = ++generation, n = liste.length, c = Math.round(pos), vus = {}, nv = 0; file = [];
      for (var d = 0; d <= AVANCE && nv < n; d++) [1, -1].slice(0, d ? 2 : 1).forEach(function(s){
        var i = (((c + s * d) % n) + n) % n; if (vus[i]) return; vus[i] = 1; nv++;
        /* la première voisine n'est plus floue (14/10) : elle reçoit l'image nette, comme le centre,
           une fois le premier écran levé */
        var m = liste[i], net = d === 0 || (ouvert && d <= 1);
        if (m.t) file.push(tuile(m, net)); if (ouvert && d <= 1 && m.pm) file.push(m.pm); if (net && m.s) file.push(m.s);
      });
      pomper(g);
    }
    function pomper(g){
      while (actives < EN_PARALLELE && file.length) {
        var src = file.shift(); if (charges[src]) continue;
        actives++; charge(src).then(function(){ actives--; if (g === generation) pomper(g); });
      }
    }

    /* ---------- le carrousel ---------- */
    var scene = $('.mts-scene');
    /* 01/10 : la tomette du centre suit d'abord la HAUTEUR de la scène (elle rétrécissait avec la
       largeur du cadre : 236 px sur tablette pour 545 px de haut). Les voisines se glissent derrière
       elle et se chevauchent : on en voit trois de chaque côté au lieu de deux. */
    function taille(){ var W = scene.clientWidth, H = scene.clientHeight, tel = W < 760;
      /* téléphone : la disposition de l'ancien carrousel, que Benjamin préférait — la tomette du
         centre et deux de chaque côté (voisines à 70 % puis 50 %). */
      var w = tel ? Math.min(W * .64, H * .84 / .866) : Math.min(W * .42, H * .82 / .866, 560);
      return tel ? { w:w, p1:w * .47, p2:w * .27, s1:.30, s2:.20 } : { w:w, p1:w * .62, p2:w * .3, s1:.38, s2:.14 }; }
    /* 14/10 : PLUS DE TOMETTES TRANSLUCIDES. Les voisines se chevauchent exprès (p1 < largeur),
       et elles étaient à 90, 68 puis 46 % d'opacité, floues dès la première : l'arête de la pièce
       de derrière se voyait à travers celle de devant, comme un hexagone fantôme. La profondeur
       passe maintenant par un assombrissement OPAQUE et par l'ombre que la pièce de devant porte
       sur celle de derrière (mt-selecteur.css) ; seule la 4ᵉ, toujours la plus en arrière,
       s'efface encore, et le flou ne commence qu'après la première voisine. */
    function style(k, Tl){
      var a = Math.min(Math.abs(k), 4), sg = k < 0 ? -1 : k > 0 ? 1 : 0;
      var x = sg * (a <= 1 ? a * Tl.p1 : Tl.p1 + (a - 1) * Tl.p2);
      var s = a <= 1 ? 1 - Tl.s1 * a : Math.max(.24, 1 - Tl.s1 - Tl.s2 * (a - 1));
      var op = a <= 3 ? 1 : Math.max(0, 4 - a);
      return { t:'translate3d(' + x.toFixed(1) + 'px,0,' + (-a * 110) + 'px) rotateY(' + (-sg * Math.min(a, 1) * 24).toFixed(1) + 'deg) scale(' + s.toFixed(3) + ')',
        op:op, f:'blur(' + (a < 1.5 ? 0 : Math.min(.8, (a - 1.5) * .5)).toFixed(2) + 'px) brightness(' + (1 - Math.min(a, 3) * .06).toFixed(3) + ') saturate(' + (1 - Math.min(a, 2) * .1).toFixed(2) + ')', z:100 - Math.round(a * 10) };
    }
    function enroule(i, p){ var n = liste.length, k = i - p; if (n > 2) { k = ((k % n) + n) % n; if (k > n / 2) k -= n; } return k; }
    /* la carte photo est une paire (tuile + épreuve) : l'image de la tuile va dans .mts-paire,
       jamais de transform sur .mts-incline (inclinaison à la souris) ni sur .mts-flotte */
    function poser(c, m, grande){
      var hote = c.querySelector('.mts-paire') || c.querySelector('.mts-incline');
      imageDe(m, grande).then(charge).then(function(src){ if (!src) return;
        var im = hote.querySelector('img');
        if (!im) { im = new Image(); im.alt = ''; im.draggable = false; hote.appendChild(im); }
        if (grande || !im.getAttribute('src')) im.src = src;
      });
    }
    /* l'épreuve de la carte photo n'est posée qu'une fois téléchargée et décodée, et seulement
       après le premier écran : jusque-là la tuile reste seule, au milieu (mt-selecteur.css), puis
       l'épreuve sort de derrière elle. Si elle manque, la carte reste en tuile seule. */
    function epreuve(c, m){
      if (!m.duo || !ouvert || c.dataset.pm) return; c.dataset.pm = '1';
      charge(m.pm).then(function(src){ var s = c.querySelector('.mts-pm'); if (!src || !m.duo || !s) return;
        s.style.backgroundImage = 'url("' + src + '")'; c.classList.add('mts-pm-ok'); });
    }
    /* posée seulement une fois décodée ; la version nette arrive quand la carte devient le centre
       ou, une fois le premier écran levé, sa première voisine (plus floue depuis le 14/10) */
    function images(c, m, a){
      var net = a < .5 || (ouvert && a < 1.5);
      if (!c.dataset.pose) { c.dataset.pose = '1'; if (net) c.dataset.nette = '1'; poser(c, m, net); }
      else if (net && !c.dataset.nette) { c.dataset.nette = '1'; poser(c, m, true); }
      /* le ciel (15/10) : son épreuve, comme sa grande tuile, attend qu'il soit au centre ou première
         voisine ; plus loin, il reste en médaillon seul, comme les modèles */
      if (m !== CIEL) epreuve(c, m);
      else if (net && ouvert) { affinerCiel(); epreuve(c, m); }
    }
    function peindre(anime){
      var Tl = taille(); scene.style.setProperty('--w', Tl.w + 'px'); scene.style.setProperty('--h', (Tl.w * .866) + 'px');
      cartes.forEach(function(c, i){
        var k = enroule(i, pos), st = style(k, Tl), a = Math.abs(k), m = liste[i];
        c.classList.toggle('mts-anime', !!anime && !reduit);
        c.style.visibility = a > 4.1 ? 'hidden' : 'visible';
        if (a > 4.1) return;
        images(c, m, a);
        c.style.transform = st.t; c.style.opacity = st.op; c.style.filter = st.f; c.style.zIndex = st.z;
        c.classList.toggle('mts-centre', a < .5); c.tabIndex = a < .5 ? 0 : -1;
      });
    }
    function batir(){
      cartes.forEach(function(c){ c.remove(); }); cartes = [];
      var Tl = taille();
      liste.forEach(function(m, i){
        var b = document.createElement('button'); b.type = 'button'; b.className = 'mts-carte' + (m.carte ? ' mts-lieu' : m.ciel ? ' mts-ciel' : ''); b.setAttribute('aria-label', m.photo ? T.photoAria : m.carte ? T.carteAria : m.ciel ? T.cielAria : m.n);
        var fv = formeVue(m), w = fv === 'hexa' ? Tl.w : Tl.w * .86, h = fv === 'hexa' ? Tl.w * .866 : Tl.w * .86;
        b.style.width = w + 'px'; b.style.height = h + 'px'; b.style.marginLeft = (-w / 2) + 'px'; b.style.marginTop = (-h / 2) + 'px'; b.style.visibility = 'hidden';
        /* l'épreuve est un span et non une img : poser() prend la première img de la carte, et
           attente.js attend une img (la tuile) au centre pour lever son voile. Son image vient
           plus tard, par epreuve(). */
        if (m.duo) { b.classList.add('mts-duo'); b.innerHTML = '<span class="mts-flotte"><span class="mts-incline"><span class="mts-paire"><span class="mts-pm"></span></span></span></span>'; }
        else b.innerHTML = '<span class="mts-flotte"><span class="mts-incline"></span></span>';
        b.addEventListener('click', function(e){ if (glisse.bouge) { e.preventDefault(); return; } var k = enroule(i, pos); if (Math.abs(k) < .5) personnaliser(); else aller(Math.round(pos + k)); });
        scene.appendChild(b); cartes.push(b);
      });
    }
    function charger(){
      liste = filtre(etat.cat);
      $('.mts-vide').hidden = liste.length > 0; scene.hidden = !liste.length; $('.mts-fiche').hidden = !liste.length;
      if (!liste.length) return;
      /* un seul modèle (la pastille « Votre photo », une recherche précise) : ni flèches ni compteur */
      scene.classList.toggle('mts-seule', liste.length === 1);
      pos = 0; courant = null; batir(); peindre(false); bouts();
      if (!reduit && cartes[0].animate) cartes.forEach(function(c, i){ var k = Math.abs(enroule(i, 0)); if (k > 4) return;
        c.animate([{ opacity:0, transform:c.style.transform + ' translateY(50px)' }, { opacity:c.style.opacity, transform:c.style.transform }], { duration:700, delay:40 + k * 80, easing:'cubic-bezier(.2,.8,.2,1)', fill:'backwards' }); });
      fiche(liste[0], true);
      planifier();
    }
    /* 14/10 : avec 1 ou 2 modèles, enroule() ne boucle plus — il n'y a pas de quoi faire un
       tour — mais rien ne bornait la position : une flèche de trop poussait les deux tomettes
       hors du centre (« Crémaillère » se décentrait). On borne, et la flèche du bout s'éteint. */
    function borne(p){ var n = liste.length; return n <= 2 ? Math.max(0, Math.min(n - 1, p)) : p; }
    function bouts(){ var n = liste.length, r = Math.round(pos);
      scene.classList.toggle('mts-bout-g', n <= 2 && r <= 0); scene.classList.toggle('mts-bout-d', n <= 2 && r >= n - 1); }
    function aller(p){ pos = borne(p); peindre(true); bouts(); fiche(liste[((Math.round(pos) % liste.length) + liste.length) % liste.length]); planifier(); }
    scene.addEventListener('pointermove', function(e){
      if (reduit || e.pointerType !== 'mouse' || glisse.actif) return;
      var c = cartes.filter(function(x){ return x.classList.contains('mts-centre'); })[0]; if (!c) return;
      var r = c.getBoundingClientRect(), dx = (e.clientX - (r.left + r.width / 2)) / r.width, dy = (e.clientY - (r.top + r.height / 2)) / r.height;
      c.querySelector('.mts-incline').style.transform = 'rotateY(' + (dx * 10).toFixed(1) + 'deg) rotateX(' + (-dy * 8).toFixed(1) + 'deg)';
    });
    scene.addEventListener('pointerleave', function(){ cartes.forEach(function(c){ c.querySelector('.mts-incline').style.transform = ''; }); });
    var glisse = { actif:false, bouge:false };
    scene.addEventListener('pointerdown', function(e){ if (e.target.closest('.mts-fleche,.mts-gosc') || !liste.length) return;
      glisse = { actif:true, bouge:false, x0:e.clientX, y0:e.clientY, p0:pos, v:0, tx:e.clientX, t:performance.now(), id:e.pointerId, axe:null }; });
    window.addEventListener('pointermove', function(e){
      if (!glisse.actif || e.pointerId !== glisse.id) return;
      var dx = e.clientX - glisse.x0, dy = e.clientY - glisse.y0;
      if (!glisse.axe) { if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return; glisse.axe = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y'; if (glisse.axe === 'x') { scene.classList.add('mts-saisie'); try { scene.setPointerCapture(e.pointerId); } catch (_) {} } }
      if (glisse.axe !== 'x') { glisse.actif = false; return; }
      glisse.bouge = true; var now = performance.now(); glisse.v = (e.clientX - glisse.tx) / Math.max(1, now - glisse.t); glisse.tx = e.clientX; glisse.t = now;
      pos = glisse.p0 - dx / taille().p1;
      if (liste.length <= 2) pos = Math.max(-.25, Math.min(liste.length - .75, pos));   /* un peu de jeu au bout, puis butée */
      peindre(false);
    });
    function lacher(){ if (!glisse.actif) return; glisse.actif = false; scene.classList.remove('mts-saisie'); if (!glisse.bouge) return;
      aller(Math.round(pos + Math.max(-1.5, Math.min(1.5, -glisse.v * 180 / taille().p1)))); setTimeout(function(){ glisse.bouge = false; }, 60); }
    window.addEventListener('pointerup', lacher); window.addEventListener('pointercancel', lacher);
    $('.mts-fg').addEventListener('click', function(){ aller(Math.round(pos) - 1); });
    $('.mts-fd').addEventListener('click', function(){ aller(Math.round(pos) + 1); });
    function visible(){ return ins.classList.contains('on') && root.offsetParent !== null; }
    document.addEventListener('keydown', function(e){
      if (!visible() || e.target === q || /^(INPUT|TEXTAREA|SELECT)$/.test((e.target || {}).tagName || '')) return;
      if (loupe.classList.contains('mts-ouverte')) { if (e.key === 'Escape') fermerLoupe(); if (e.key === 'ArrowRight') photo(1); if (e.key === 'ArrowLeft') photo(-1); e.stopPropagation(); return; }
      if (e.key === 'ArrowRight') { aller(Math.round(pos) + 1); e.stopPropagation(); }
      if (e.key === 'ArrowLeft') { aller(Math.round(pos) - 1); e.stopPropagation(); }
    }, true);

    /* ---------- la petite fiche ---------- */
    /* Deux sortes de planches : la bande de 4 photos produit des modèles (m.s, une image), ou,
       pour la tomette photo, une LISTE d'images (m.ph) : l'épreuve, la tuile gravée, puis des
       photos réelles du produit. La tuile est détourée : elle se montre entière (contain) sur
       le fond crème des rendus. L'épreuve aussi reste entière, posée sur ce crème : son bord
       blanc fait partie de l'image (5/6), et un « cover » dans la vignette carrée le rognait
       en haut et en bas seulement. Dans la loupe, les deux restent entières, sur le voile.
       Les photos du produit arrivent en 1 200 px (160 à 210 Ko chacune) : une vignette de
       moins de 100 px les demande en 360 px au CDN de la boutique (31 à 39 Ko). */
    function nPhotos(m){ return m.ph ? m.ph.length : (m.sn || 1); }
    function leger(u){
      if (!/\/cdn\/shop\//.test(u)) return u;
      return /[?&]width=\d+/.test(u) ? u.replace(/([?&]width=)\d+/, '$1360') : u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=360';
    }
    function sprite(el, m, i, loupe){
      /* carte gravée (15/10) : sa gravure carreau (m.tC) est elle aussi une tuile détourée, entière */
      if (m.ph) { var u = m.ph[i] || m.ph[0], tuile = u === m.t || u === m.v || (!!m.tC && u === m.tC), epreuve = u === m.pm, entier = tuile || epreuve;
        el.style.backgroundImage = 'url("' + (entier || loupe ? u : leger(u)) + '")'; el.style.backgroundSize = !entier ? 'cover' : loupe ? 'contain' : tuile ? '82% auto' : 'auto 86%';
        el.style.backgroundPosition = 'center'; el.style.backgroundColor = loupe ? 'transparent' : (entier ? '#F3EEE8' : ''); return; }
      var n = m.sn || 1; el.style.backgroundImage = 'url(' + m.s + ')'; el.style.backgroundSize = (n * 100) + '% 100%'; el.style.backgroundPosition = (n > 1 ? i / (n - 1) * 100 : 0) + '% 0'; el.style.backgroundColor = '';
    }
    /* /en : « €24.90 », comme le reste de l'éditeur anglais ; /fr : « 24,90 € » */
    function eur(v){ return EN ? '€' + v.toFixed(2) : v.toFixed(2).replace('.', ',') + ' €'; }
    var go = $('.mts-go'), gosc = $('.mts-gosc');
    function libelles(m){
      var en = !!(m && m.photo), ca = !!(m && m.carte), ci = !!(m && m.ciel);
      var html = (en ? T.photoGo : ca ? T.carteGo : ci ? T.cielGo : T.go) + ' ' + SVG.fl, court = (en ? T.photoGoCourt : ca ? T.carteGoCourt : ci ? T.cielGoCourt : T.goCourt) + ' ' + SVG.fl;
      if (go._mtsL !== html) { go._mtsL = html; if (!go.getAttribute('aria-busy')) go.innerHTML = html; }
      if (gosc._mtsL !== court) { gosc._mtsL = court; if (!gosc.getAttribute('aria-busy')) gosc.innerHTML = court; }
    }
    function fiche(m, direct){
      if (courant === m) return; courant = m;
      /* « Ouverture… » n'appartient qu'à la carte photo : le client a fait défiler jusqu'à un autre
         modèle, la demande tombe (plus de départ vers la fiche photo) et le bouton redevient le sien */
      if (abandon && !(m && m.photo)) abandon();
      /* même règle pour la carte gravée : sa demande tombe quand on la quitte */
      if (abandonC && !(m && m.carte)) abandonC();
      if (abandonCi && !(m && m.ciel)) abandonCi();   /* … et pour le ciel (15/10) */
      libelles(m); majAttente(); majNote();
      var i = liste.indexOf(m);
      $('.mts-num').textContent = i + 1; $('.mts-tot').textContent = liste.length; $('.mts-barre i').style.width = ((i + 1) / liste.length * 100) + '%';
      function remplir(){
        /* la catégorie du modèle devient un raccourci vers ses voisins de thème */
        var fil = $('.mts-fil'), nCat = mods.filter(function(x){ return x.c === m.c; }).length;
        fil.textContent = NOMS[m.c] || '';
        if (NOMS[m.c] && etat.cat !== m.c && nCat > 1) {
          var va = document.createElement('span'); va.className = 'mts-fil-va'; va.textContent = ' · ' + (EN ? 'see the ' + nCat + ' designs' : 'voir les ' + nCat + ' modèles') + ' →';
          fil.appendChild(va); fil.disabled = false; fil.dataset.c = m.c;
        } else { fil.disabled = true; delete fil.dataset.c; }
        $('.mts-nom').textContent = m.n;
        var pu = $('.mts-puces'); pu.innerHTML = '';
        var P = m.prix || PRIX;   /* tomette photo : ses propres prix (24,90 € …), pas ceux de la classique */
        var fs = (m.sh && m.sh.length ? m.sh : [m.f]).filter(function(f){ return P[f]; });
        var f0 = formeVue(m), ordre = [f0].concat(fs.filter(function(f){ return f !== f0; })).filter(function(f){ return P[f]; });
        if (ordre.length) {
          var prix = document.createElement('span'); prix.className = 'mts-puce mts-prix';
          var sm = document.createElement('small'); sm.textContent = T.aPartir; var bb = document.createElement('b'); bb.textContent = eur(Math.min.apply(null, ordre.map(function(f){ return P[f]; })));
          prix.appendChild(sm); prix.appendChild(bb); pu.appendChild(prix);
          ordre.forEach(function(f){ var s = document.createElement('span'); s.className = 'mts-puce'; s.textContent = T.fmt[f] || f; pu.appendChild(s); });
        }
        var vg = $('.mts-vignettes'); vg.innerHTML = '';
        /* les photos du produit se numérotent à partir de 1, après l'épreuve et la tuile */
        function nomVig(k){ var u = m.ph && m.ph[k], sp = function(x){ return x === m.pm || x === m.t || x === m.v || (!!m.tC && x === m.tC); };
          if (!m.ph) return T.photo + (k + 1);
          /* carte gravée : le plan d'exemple, la tomette gravée, le carreau gravé, puis les photos */
          return u === m.pm ? (m.carte ? T.vigPlan : m.ciel ? T.vigCiel : T.vigEpreuve) : (m.tC && u === m.tC) ? T.vigCarreau : sp(u) ? T.vigGravure : T.photo + (k + 1 - m.ph.slice(0, k).filter(sp).length); }
        /* la fiche photo est celle du premier écran : ses vignettes attendent qu'il soit levé */
        if (m.ph || m.s) for (var k = 0; k < nPhotos(m); k++) (function(k){ var v = document.createElement('button'); v.type = 'button'; v.className = 'mts-vig'; v.setAttribute('aria-label', nomVig(k));
          if (m.ph && !ouvert) apres.push(function(){ if (v.isConnected) sprite(v, m, k); }); else sprite(v, m, k);
          v.addEventListener('click', function(){ ouvrirLoupe(k); }); vg.appendChild(v); })(k);
        else { var v = document.createElement('div'); v.className = 'mts-vig mts-rendu'; imageDe(m, false).then(function(u){ if (u && courant === m) v.style.backgroundImage = 'url(' + u + ')'; }); vg.appendChild(v);
          var s = document.createElement('span'); s.className = 'mts-sansphoto'; s.textContent = T.sansPhoto; vg.appendChild(s); }
      }
      var info = $('.mts-infos');
      if (direct || reduit || !info.animate) { remplir(); return; }
      info.animate([{ opacity:1 }, { opacity:0, transform:'translateY(6px)' }], { duration:140, easing:'ease-in' }).onfinish = function(){
        remplir();
        Array.prototype.forEach.call($('.mts-vignettes').children, function(el, k){ el.animate([{ opacity:0, transform:'translateY(10px) scale(.94)' }, { opacity:1, transform:'none' }], { duration:380, delay:k * 50, easing:'cubic-bezier(.2,.8,.2,1)', fill:'backwards' }); });
        Array.prototype.forEach.call(info.children, function(el, k){ el.animate([{ opacity:0, transform:'translateY(8px)' }, { opacity:1, transform:'none' }], { duration:380, delay:60 + k * 40, easing:'cubic-bezier(.2,.8,.2,1)', fill:'backwards' }); });
      };
    }
    $('.mts-fil').addEventListener('click', function(){ var c = this.dataset.c; if (!c || c === etat.cat) return;
      var garde = courant; etat.cat = c; majRuban(true); charger();
      var i = liste.indexOf(garde); if (i > 0) { pos = i; peindre(false); bouts(); fiche(garde, true); planifier(); } });
    /* ---------- la photo en grand ---------- */
    var loupe = $('.mts-loupe'), grand = $('.mts-grand'), li = 0;
    function ouvrirLoupe(k){ li = k; sprite(grand, courant, li, true); loupe.classList.add('mts-ouverte'); loupe.setAttribute('aria-hidden', 'false'); try { $('.mts-rond').focus({ preventScroll:true }); } catch (e) {} }
    function fermerLoupe(){ loupe.classList.remove('mts-ouverte'); loupe.setAttribute('aria-hidden', 'true'); }
    function photo(s){ var n = nPhotos(courant); li = (li + s + n) % n; sprite(grand, courant, li, true); }
    $('.mts-rond').addEventListener('click', fermerLoupe); loupe.addEventListener('click', function(e){ if (e.target === loupe) fermerLoupe(); });
    $('.mts-nav.mts-g').addEventListener('click', function(){ photo(-1); }); $('.mts-nav.mts-d').addEventListener('click', function(){ photo(1); });

    /* ---------- ouvrir l'éditeur : le moteur fait le reste ---------- */
    function personnaliser(){ if (!courant) return; try { C.mtTrack && C.mtTrack('cfg_selecteur', { id:courant.id }); } catch (e) {}
      if (courant.photo) { ouvrirPhoto(); return; }
      /* un ciel en cours d'ouverture fait attendre la carte (une vedette à la fois) : la garde est
         posée ici, pour qu'ouvrirCarte, déjà en ligne, reste identique à l'octet (relecture du 15/10) */
      if (courant.carte) { if (vedetteOuverte() === 'ciel') return; ouvrirCarte(); return; }
      if (courant.ciel) { ouvrirCiel(); return; }
      if (abandon) abandon();   /* il a choisi un autre modèle pendant « Ouverture… » : la photo n'est plus demandée */
      if (abandonC) abandonC();   /* … ni la carte */
      if (abandonCi) abandonCi();   /* … ni le ciel */
      C.loadTemplate(courant.tpl); }

    /* ---------- la tomette photo : ouvrir l'atelier photo, ou la fiche photo ----------
       Le mode photo vit dans un module de la couche d'édition (MT_PHOTO_EXPERT), chargé À PART
       et après les autres : il peut ne pas être encore là au premier clic. Trois cas :
       · il est là : il ouvre la démo et la feuille « Ajouter une photo ». Sur un téléphone, cela
         prend quelques secondes (démo de 300 Ko, découpe) : le bouton dit « Ouverture… » jusqu'à
         ce que l'éditeur prenne l'écran ou que sa promesse se termine (20 s au plus), et un second
         appui ne relance rien. S'il échoue sans rien avoir montré (promesse rejetée), le client qui
         attend toujours devant la carte part vers la fiche photo plutôt que de rester devant un
         bouton qui ne fait rien ;
       · la couche est éteinte (?sans-editeur) ou le module a échoué : la fiche photo, tout de suite ;
       · il se charge encore : on dépose la demande (window.__mtPhotoDemande, qu'il lit et
         EFFACE à son démarrage), le bouton dit « Ouverture… », et on n'envoie vers la fiche
         qu'au bout de 15 s sans signe de vie. Dès qu'il annonce « mtp:pret », on ne quitte
         plus jamais la page : c'est lui qui a la main. Aucune confirmation ici, comme pour
         un modèle (loadTemplate).
       Jamais d'éjection à tort : « Ouverture… » n'appartient qu'à la carte photo. Si le client
       fait défiler vers un autre modèle ou choisit la page blanche, la demande tombe. Et on ne
       part vers la fiche que s'il attend toujours devant la carte photo, page réellement à
       l'écran : volet de la boutique ouvert, onglet au premier plan (aLEcran). Parti dans
       l'éditeur, volet refermé, onglet changé : on ne l'emporte nulle part. */
    var demande = null, abandon = null, ouvrant = null;
    function patienter(on){
      [go, gosc].forEach(function(b){
        /* aria-disabled et non disabled : le focus clavier reste sur le bouton pendant l'attente */
        if (on) { if (b.getAttribute('aria-busy')) return; b.setAttribute('aria-busy', 'true'); b.setAttribute('aria-disabled', 'true'); b.innerHTML = '<span class="mts-roue" aria-hidden="true"></span>' + esc(T.ouverture); }
        else if (b.getAttribute('aria-busy')) { b.removeAttribute('aria-busy'); b.removeAttribute('aria-disabled'); b.innerHTML = b._mtsL || b.innerHTML; }
      });
    }
    /* relecture du 15/10 : une seule vedette s'ouvre à la fois. Si l'une est en cours d'ouverture
       et que le client regarde l'AUTRE vedette (il a fait défiler pendant que le module travaille),
       le bouton de celle-ci dit aussi « Ouverture… » : un appui n'y ferait rien, il le sait. Sans
       carte gravée, c'est exactement la règle d'avant (seule la photo, sur la carte photo). */
    function majAttente(){ patienter(!!vedetteOuverte() && !!(courant && (courant.photo || courant.carte || courant.ciel))); }
    /* Le carrousel est-il VRAIMENT sous les yeux du client ? visible() ne suffit pas : dans le volet
       de la boutique (iframe srcdoc), « Fermer » masque le volet (visibility:hidden) et garde
       l'iframe vivante pour la rendre telle quelle ; dedans, #sInsp reste allumé. On remonte donc
       les cadres : onglet au premier plan, et chaque iframe hôte affichée, dans la fenêtre, et pas
       en train de s'effacer (le volet se referme par un fondu de 0,4 s, pendant lequel il est
       encore « visible »). Un cadre qu'on ne peut pas lire (autre origine) : on ne sait pas, on
       s'abstient. Ne pas partir est toujours l'erreur la moins grave. */
    function aLEcran(){
      if (!visible()) return false;
      try {
        for (var w = window; ; w = w.parent) {
          if (w.document.visibilityState === 'hidden') return false;
          if (w === w.top) return true;
          var fe = w.frameElement; if (!fe) return false;
          var vue = fe.ownerDocument.defaultView, r = fe.getBoundingClientRect(), op = 1;
          if (vue.getComputedStyle(fe).visibility !== 'visible' || !fe.getClientRects().length) return false;
          if (r.bottom <= 0 || r.right <= 0 || r.top >= vue.innerHeight || r.left >= vue.innerWidth) return false;
          for (var n = fe; n && n.nodeType === 1; n = n.parentElement) op *= +vue.getComputedStyle(n).opacity;
          if (op < .5) return false;
        }
      } catch (e) { return false; }
    }
    function versFiche(){
      demande = null; if (window.__mtPhotoDemande) window.__mtPhotoDemande = null; majAttente();
      var u = PH && PH.produit && PH.produit.url; if (!u) return;
      /* dans le volet de la boutique (iframe srcdoc, même origine), c'est la page entière qui part */
      try { (window.top || window).location.href = u; } catch (e) { location.href = u; }
    }
    /* le recours : la fiche photo, seulement pour un client qui attend toujours devant la carte */
    function recours(){ if (courant && courant.photo && aLEcran()) versFiche(); }
    function avertir(e){ try { console.warn('[photo]', e); } catch (_) {} }
    /* Une ouverture est en cours : « Ouverture… » jusqu'à ce que l'éditeur prenne l'écran (le
       carrousel s'éteint, l'observateur plus bas y met fin), que la promesse du module se termine,
       ou au plafond. La promesse de MT_PHOTO_EXPERT.ouvrir() peut durer bien après l'ouverture
       (elle attend le choix de la photo, feuille ouverte) : c'est l'écran qui compte. */
    function suivre(d, plafondMs){
      if (ouvrant) ouvrant.fin();
      var moi = ouvrant = { d:d, fin:fin }, plafond = setTimeout(fin, plafondMs);
      majAttente();
      function fin(){ if (ouvrant !== moi) return false; ouvrant = null; clearTimeout(plafond); majAttente(); return true; }
      return moi;
    }
    /* le module est là : une seule ouverture à la fois depuis le carrousel */
    function lancer(M, d){
      if (ouvrant) return;
      var moi = suivre(d, 20000), r;
      try { r = M.ouvrir(d); } catch (e) { avertir(e); if (moi.fin()) recours(); return; }
      Promise.resolve(r).then(moi.fin, function(e){ avertir(e); if (moi.fin()) recours(); });
    }
    function ouvrirPhoto(){
      if (demande || ouvrant || (vedetteOuverte() !== null && vedetteOuverte() !== 'photo')) return;   /* un second appui pendant l'ouverture ne relance rien ; ni une autre vedette (carte, ciel) en cours d'ouverture (15/10) */
      var d = { depuis:'carrousel', forme:etat.forme === 'carree' ? 'carree' : 'hexa' };
      var X = window.MT_PHOTO_EXPERT, couche = document.documentElement.classList.contains('mt-kiosk');
      if (X && typeof X.ouvrir === 'function') { lancer(X, d); return; }
      if (!couche || window.__MTPX_ECHEC__) { versFiche(); return; }
      demande = d; window.__mtPhotoDemande = d; majAttente();
      var fini = false;
      function finir(annule){ if (fini) return false; fini = true; demande = null; abandon = null;
        document.removeEventListener('mtp:pret', pret); document.removeEventListener('mtp:echec', echec); clearTimeout(minute);
        if (annule && window.__mtPhotoDemande === d) window.__mtPhotoDemande = null;
        majAttente(); return true; }
      /* aucun signe du module, ou son échec : la demande tombe, et la fiche photo si le client attend */
      function ficheSiAttend(){ if (window.__mtPhotoDemande !== d) return; window.__mtPhotoDemande = null; recours(); }
      function pret(ev){
        var prise = !!(ev && ev.detail && ev.detail.demandePrise);
        /* un tour plus tard : le module peut effacer la demande juste après avoir annoncé « prêt » ;
           « Ouverture… » reste affiché jusque-là, sans clignoter */
        setTimeout(function(){
          if (!finir()) return;
          var attend = !!(courant && courant.photo && aLEcran()), M = window.MT_PHOTO_EXPERT;
          /* il l'a prise (effacée, ou il le dit dans mtp:pret) : il a la main. Il peut encore finir de
             s'installer avant d'ouvrir (sa feuille de style) : « Ouverture… » reste jusqu'à ce que
             l'éditeur prenne l'écran, 10 s au plus. */
          if (window.__mtPhotoDemande !== d || prise) { if (window.__mtPhotoDemande === d) window.__mtPhotoDemande = null; if (attend) suivre(d, 10000); return; }
          window.__mtPhotoDemande = null;
          /* pas prise : on la lui passe, une seule fois, si le client attend toujours devant la carte.
             Plus à l'écran (éditeur déjà ouvert, volet refermé) : rien. */
          if (attend && M && typeof M.ouvrir === 'function') lancer(M, d);
        }, 0);
      }
      function echec(){ if (finir()) ficheSiAttend(); }
      abandon = function(){ finir(true); };
      document.addEventListener('mtp:pret', pret); document.addEventListener('mtp:echec', echec);
      var minute = setTimeout(function(){ if (finir()) ficheSiAttend(); }, 15000);
    }

    /* ---------- la carte gravée : ouvrir le mode carte, ou la fiche carte (15/10/2026) ----------
       COPIE DE ouvrirPhoto et de ses auxiliaires (lancer, suivre, recours, versFiche), sur des noms
       à elle : MT_CARTE_EXPERT, window.__mtCarteDemande, mtcx:pret, mtcx:echec, __MTCX_ECHEC__
       (contrats carte §3 et §10). Le code de la photo, validé mais pas encore publié, n'est PAS
       factorisé (cahier carte D30) : la fusion viendra avec le pont commun, après les deux mises
       en ligne. Mêmes règles : « Ouverture… » n'appartient qu'à la carte vedette, aucune éjection
       à tort, 15 s sans signe de vie au plus, la demande est remise à null par le module AVANT
       mtcx:pret. Une différence : la fiche carte n'existe pas tant que le produit n'est pas publié
       (ficheUrl null). Sans module ni fiche, la vedette RESTE et dit « momentanément
       indisponible » ; on ne charge jamais l'exemple sans le module (le Vieux-Port resterait sous
       un lieu retapé à la main, sans recherche ni recadrage).
       Une seule ouverture de vedette à la fois : window.__mtVedetteOuverte (« photo », « carte »
       ou null) se lit sur l'état des deux ouvertures, il ne peut donc pas rester levé à tort. */
    var demandeC = null, abandonC = null, ouvrantC = null, carteIndispo = false;
    /* 15/10 (ciel) : « photo », « carte », « ciel » ou null ; les variables du ciel sont déclarées
       plus bas (hissées par var : null avant leur première écriture) */
    function vedetteOuverte(){ return (demande || ouvrant) ? 'photo' : (demandeC || ouvrantC) ? 'carte' : (demandeCi || ouvrantCi) ? 'ciel' : null; }
    try { Object.defineProperty(window, '__mtVedetteOuverte', { configurable:true, get:vedetteOuverte, set:function(){} }); } catch (e) {}
    /* la note sous le nom : seulement sur la vedette qui a échoué (carte, ou ciel depuis le 15/10),
       après un échec d'ouverture */
    function majNote(){ var n = $('.mts-note'); if (!n) return;
      var txt = carteIndispo && !!(courant && courant.carte) ? T.carteIndispo : cielIndispo && !!(courant && courant.ciel) ? T.cielIndispo : '';
      if (txt && n.textContent !== txt) n.textContent = txt; n.hidden = !txt; }
    function avertirC(e){ try { console.warn('[carte]', e); } catch (_) {} }
    function versFicheCarte(){
      demandeC = null; if (window.__mtCarteDemande) window.__mtCarteDemande = null; majAttente();
      var u = CA && CA.ficheUrl;
      if (!u) { carteIndispo = true; majNote(); avertirC('mode carte indisponible et fiche carte non publiée'); return; }
      try { (window.top || window).location.href = u; } catch (e) { location.href = u; }
    }
    function recoursCarte(){ if (courant && courant.carte && aLEcran()) versFicheCarte(); }
    function suivreC(d, plafondMs){
      if (ouvrantC) ouvrantC.fin();
      var moi = ouvrantC = { d:d, fin:fin }, plafond = setTimeout(fin, plafondMs);
      majAttente();
      function fin(){ if (ouvrantC !== moi) return false; ouvrantC = null; clearTimeout(plafond); majAttente(); return true; }
      return moi;
    }
    function lancerC(M, d){
      if (ouvrantC) return;
      var moi = suivreC(d, 20000), r;
      try { r = M.ouvrir(d); } catch (e) { avertirC(e); if (moi.fin()) recoursCarte(); return; }
      /* le contrat dit « jamais rejetée » ; un rejet est traité comme un échec, par prudence */
      Promise.resolve(r).then(moi.fin, function(e){ avertirC(e); if (moi.fin()) recoursCarte(); });
    }
    function ouvrirCarte(){
      if (demandeC || ouvrantC || vedetteOuverte() === 'photo') return;   /* un second appui, ou une photo en cours d'ouverture */
      carteIndispo = false; majNote();   /* un nouvel essai efface la note */
      var d = { depuis:'carrousel', forme:etat.forme === 'carree' ? 'carree' : 'hexa' };
      var X = window.MT_CARTE_EXPERT, couche = document.documentElement.classList.contains('mt-kiosk');
      if (X && typeof X.ouvrir === 'function' && !X.inerte) { lancerC(X, d); return; }
      if (!couche || window.__MTCX_ECHEC__) { versFicheCarte(); return; }
      demandeC = d; window.__mtCarteDemande = d; majAttente();
      var fini = false;
      function finir(annule){ if (fini) return false; fini = true; demandeC = null; abandonC = null;
        document.removeEventListener('mtcx:pret', pret); document.removeEventListener('mtcx:echec', echec); clearTimeout(minute);
        if (annule && window.__mtCarteDemande === d) window.__mtCarteDemande = null;
        majAttente(); return true; }
      function ficheSiAttend(){ if (window.__mtCarteDemande !== d) return; window.__mtCarteDemande = null; recoursCarte(); }
      function pret(ev){
        var prise = !!(ev && ev.detail && ev.detail.demandePrise);
        setTimeout(function(){
          if (!finir()) return;
          var attend = !!(courant && courant.carte && aLEcran()), M = window.MT_CARTE_EXPERT;
          if (window.__mtCarteDemande !== d || prise) { if (window.__mtCarteDemande === d) window.__mtCarteDemande = null; if (attend) suivreC(d, 10000); return; }
          window.__mtCarteDemande = null;
          if (attend && M && typeof M.ouvrir === 'function' && !M.inerte) lancerC(M, d);
        }, 0);
      }
      function echec(){ if (finir()) ficheSiAttend(); }
      abandonC = function(){ finir(true); };
      document.addEventListener('mtcx:pret', pret); document.addEventListener('mtcx:echec', echec);
      var minute = setTimeout(function(){ if (finir()) ficheSiAttend(); }, 15000);
    }

    /* ---------- la carte du ciel : ouvrir le mode ciel, ou la fiche ciel (15/10/2026) ----------
       COPIE DE ouvrirCarte et de ses auxiliaires (lancerC, suivreC, recoursCarte, versFicheCarte),
       sur des noms à lui : MT_CIEL_EXPERT, window.__mtCielDemande, mtci:pret, mtci:echec,
       __MTCI_ECHEC__ (contrats ciel §3 et §10). ouvrirCarte n'est PAS factorisée (cahier ciel §4.1,
       critique M5) : en V1.1, un descripteur VEDETTES[cle] remplacera les deux copies, une fois la
       carte publiée et stable. Mêmes règles, mêmes délais (20 s, 15 s, 10 s) : « Ouverture… »
       n'appartient qu'à la vedette ciel, aucune éjection à tort, la demande est remise à null par le
       module AVANT mtci:pret. Sans module ni fiche publiée (ficheUrl null), la vedette RESTE et dit
       « momentanément indisponible » ; on ne charge jamais l'exemple sans le module. */
    var demandeCi = null, abandonCi = null, ouvrantCi = null, cielIndispo = false;
    function avertirCi(e){ try { console.warn('[ciel]', e); } catch (_) {} }
    function versFicheCiel(){
      demandeCi = null; if (window.__mtCielDemande) window.__mtCielDemande = null; majAttente();
      var u = CI && CI.ficheUrl;
      if (!u) { cielIndispo = true; majNote(); avertirCi('mode ciel indisponible et fiche ciel non publiée'); return; }
      try { (window.top || window).location.href = u; } catch (e) { location.href = u; }
    }
    function recoursCiel(){ if (courant && courant.ciel && aLEcran()) versFicheCiel(); }
    function suivreCi(d, plafondMs){
      if (ouvrantCi) ouvrantCi.fin();
      var moi = ouvrantCi = { d:d, fin:fin }, plafond = setTimeout(fin, plafondMs);
      majAttente();
      function fin(){ if (ouvrantCi !== moi) return false; ouvrantCi = null; clearTimeout(plafond); majAttente(); return true; }
      return moi;
    }
    function lancerCi(M, d){
      if (ouvrantCi) return;
      var moi = suivreCi(d, 20000), r;
      try { r = M.ouvrir(d); } catch (e) { avertirCi(e); if (moi.fin()) recoursCiel(); return; }
      /* le contrat dit « jamais rejetée » ; un rejet est traité comme un échec, par prudence */
      Promise.resolve(r).then(moi.fin, function(e){ avertirCi(e); if (moi.fin()) recoursCiel(); });
    }
    function ouvrirCiel(){
      if (demandeCi || ouvrantCi || (vedetteOuverte() !== null && vedetteOuverte() !== 'ciel')) return;   /* un second appui, ou une autre vedette en cours d'ouverture */
      cielIndispo = false; majNote();   /* un nouvel essai efface la note */
      var d = { depuis:'carrousel', forme:etat.forme === 'carree' ? 'carree' : 'hexa' };
      var X = window.MT_CIEL_EXPERT, couche = document.documentElement.classList.contains('mt-kiosk');
      if (X && typeof X.ouvrir === 'function' && !X.inerte) { lancerCi(X, d); return; }
      if (!couche || window.__MTCI_ECHEC__) { versFicheCiel(); return; }
      demandeCi = d; window.__mtCielDemande = d; majAttente();
      var fini = false;
      function finir(annule){ if (fini) return false; fini = true; demandeCi = null; abandonCi = null;
        document.removeEventListener('mtci:pret', pret); document.removeEventListener('mtci:echec', echec); clearTimeout(minute);
        if (annule && window.__mtCielDemande === d) window.__mtCielDemande = null;
        majAttente(); return true; }
      function ficheSiAttend(){ if (window.__mtCielDemande !== d) return; window.__mtCielDemande = null; recoursCiel(); }
      function pret(ev){
        var prise = !!(ev && ev.detail && ev.detail.demandePrise);
        setTimeout(function(){
          if (!finir()) return;
          var attend = !!(courant && courant.ciel && aLEcran()), M = window.MT_CIEL_EXPERT;
          if (window.__mtCielDemande !== d || prise) { if (window.__mtCielDemande === d) window.__mtCielDemande = null; if (attend) suivreCi(d, 10000); return; }
          window.__mtCielDemande = null;
          if (attend && M && typeof M.ouvrir === 'function' && !M.inerte) lancerCi(M, d);
        }, 0);
      }
      function echec(){ if (finir()) ficheSiAttend(); }
      abandonCi = function(){ finir(true); };
      document.addEventListener('mtci:pret', pret); document.addEventListener('mtci:echec', echec);
      var minute = setTimeout(function(){ if (finir()) ficheSiAttend(); }, 15000);
    }
    /* L'exemple précalculé (Vieux-Port, ~20-30 Ko) est demandé une fois la grande tuile de la
       vedette chargée (affiner), le premier écran levé et au repos du navigateur : au clic, le
       module le trouve dans le cache HTTP. Jamais en mode « économie de données ».
       Relecture du 15/10 : MÊME mode de requête que carte-expert.js (credentials:'omit') — Firefox
       range à part, dans son cache, les requêtes anonymes et les autres ; on revérifie au moment de
       tirer que la carte est toujours là (retirée entre-temps : rien) ; et le moteur de rendu
       (mt-carte-rendu.js), que le module attend aussi avant d'ouvrir, est préchauffé par la garde
       d'export (__MT_FOND_EXPORT__.prechauffer : le script seul, ni worker ni tuiles). */
    var exemplePris = false;
    function prechargerExemple(){
      if (exemplePris || !CARTE || mods.indexOf(CARTE) < 0) return; exemplePris = true;
      try { if (navigator.connection && navigator.connection.saveData) return; } catch (e) {}
      var a = (CA && CA.assets) || {}, u = etat.forme === 'carree' ? a.demoCarree : a.demoHexa; if (!u) return;
      var tirer = function(){
        if (mods.indexOf(CARTE) < 0) return;
        try { fetch(u, { credentials:'omit' }).catch(function(){}); } catch (e) {}
        try { var g = window.__MT_FOND_EXPORT__; if (g && typeof g.prechauffer === 'function') g.prechauffer(); } catch (e) {}
      };
      if (window.requestIdleCallback) requestIdleCallback(tirer, { timeout:4000 }); else setTimeout(tirer, 1500);
    }
    /* même chose pour l'exemple du ciel (mt-expert-ciel-demo-{hexa|carree}.svg, ≤ 200 Ko, cahier ciel
       §4.2) : une fois sa grande tuile chargée, au repos, jamais en « économie de données », même mode
       de requête que le module ; et le seul script de rendu du ciel, préchauffé par la garde
       (prechauffer('ciel') : ni worker ni catalogue). */
    var exempleCielPris = false;
    function prechargerExempleCiel(){
      if (exempleCielPris || !CIEL || mods.indexOf(CIEL) < 0) return; exempleCielPris = true;
      try { if (navigator.connection && navigator.connection.saveData) return; } catch (e) {}
      var a = (CI && CI.assets) || {}, u = etat.forme === 'carree' ? a.demoCarree : a.demoHexa; if (!u) return;
      var tirer = function(){
        if (mods.indexOf(CIEL) < 0) return;
        try { fetch(u, { credentials:'omit' }).catch(function(){}); } catch (e) {}
        try { var g = window.__MT_FOND_EXPORT__; if (g && typeof g.prechauffer === 'function') g.prechauffer('ciel'); } catch (e) {}
      };
      if (window.requestIdleCallback) requestIdleCallback(tirer, { timeout:4000 }); else setTimeout(tirer, 1500);
    }
    go.addEventListener('click', personnaliser); gosc.addEventListener('click', personnaliser);
    $('.mts-blanche').addEventListener('click', function(){ if (abandon) abandon(); if (abandonC) abandonC(); if (abandonCi) abandonCi(); C.loadBlank(); });

    var tr = 0; window.addEventListener('resize', function(){ clearTimeout(tr); tr = setTimeout(function(){ if (!root.offsetWidth) return; majRuban(false); majForme(); var p = pos; batir(); pos = p; peindre(false); }, 160); });
    /* ---------- dans le popup : le titre et la loupe montent dans la barre du popup ----------
       (barre de la page d'accueil, même site : on y a accès). Ils n'y sont que tant que
       le sélecteur est à l'écran ; dans l'éditeur, la barre redevient celle d'avant. */
    var hote = null, syncBarre = function(){};
    try { if (window.frameElement && window.parent !== window) hote = window.parent.document.querySelector('.musee-config-bar'); } catch (e) { hote = null; }
    if (hote && hote.querySelector('.musee-config-barL') && hote.querySelector('.musee-config-barR')) {
      var hd = hote.ownerDocument;
      Array.prototype.forEach.call(hd.querySelectorAll('.mts-hb'), function(n){ n.parentNode.removeChild(n); });
      var st = hd.getElementById('mts-hb-style'); if (!st) { st = hd.createElement('style'); st.id = 'mts-hb-style'; hd.head.appendChild(st); }
      st.textContent =
        '.musee-config-bar .mts-hb{display:none}' +
        '.musee-config-bar.mts-hb-on .mts-hb{display:flex}' +
        '.musee-config-bar.mts-hb-on .musee-config-ttl,.musee-config-bar.mts-hb-on .musee-config-prog{display:none}' +
        '.musee-config-bar .mts-hb-titre{align-items:baseline;font:400 clamp(1.3rem,2.1vw,1.75rem)/1 "Instrument Serif",Georgia,serif;color:#1F1814;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0;gap:.28em}' +
        '.musee-config-bar .mts-hb-titre em{font-style:italic;color:#C35F36}' +
        '.musee-config-bar .mts-hb-cherche{align-items:center;gap:8px;height:40px;padding:0 14px;border:1px solid rgba(13,13,13,.22);border-radius:999px;background:#fff;cursor:text;margin:0}' +
        '.musee-config-bar .mts-hb-cherche svg{width:15px;height:15px;flex:none;color:#6E6E6E}' +
        '.musee-config-bar .mts-hb-cherche input{border:0;outline:0;background:none;padding:0;margin:0;box-shadow:none;width:170px;font:600 .84rem "Archivo",sans-serif;color:#1F1814;-webkit-appearance:none;appearance:none}' +
        '@media (max-width:760px){.musee-config-bar .mts-hb-titre{font-size:1.28rem}' +
          '.musee-config-bar .mts-hb-cherche{width:40px;padding:0;justify-content:center;transition:width .3s}' +
          '.musee-config-bar .mts-hb-cherche input{width:0}' +
          '.musee-config-bar .mts-hb-cherche.mts-ouverte{width:calc(100vw - 150px);padding:0 12px;justify-content:flex-start}' +
          '.musee-config-bar .mts-hb-cherche.mts-ouverte input{width:100%;font-size:16px}' +
          '.musee-config-bar.mts-hb-on:has(.mts-hb-cherche.mts-ouverte) .mts-hb-titre{display:none}}';
      var titre = hd.createElement('div'); titre.className = 'mts-hb mts-hb-titre'; titre.innerHTML = T.titre;
      var ch = hd.createElement('label'); ch.className = 'mts-hb mts-hb-cherche';
      ch.innerHTML = SVG.loupe + '<input type="search" placeholder="' + T.chercher + '" aria-label="' + T.chercherAria + '" autocomplete="off">';
      hote.querySelector('.musee-config-barL').appendChild(titre);
      var barR = hote.querySelector('.musee-config-barR'); barR.insertBefore(ch, barR.firstChild);
      var qh = ch.querySelector('input');
      qh.addEventListener('input', function(){ chercher(qh.value); });
      ch.addEventListener('click', function(){ ch.classList.add('mts-ouverte'); qh.focus(); });
      qh.addEventListener('blur', function(){ if (!qh.value) ch.classList.remove('mts-ouverte'); });
      root.classList.add('mts-heberge');
      syncBarre = function(){ hote.classList.toggle('mts-hb-on', ins.classList.contains('on')); };
      window.addEventListener('pagehide', function(){ hote.classList.remove('mts-hb-on'); if (titre.parentNode) titre.parentNode.removeChild(titre); if (ch.parentNode) ch.parentNode.removeChild(ch); });
    }
    syncBarre();
    /* l'écran peut être caché au démarrage (lien direct vers une recette) : on se remet en place à son retour */
    if (window.MutationObserver) new MutationObserver(function(){ syncBarre();
      /* l'éditeur a pris l'écran : l'ouverture photo en cours a abouti, le bouton redevient le sien */
      if (ouvrant && !ins.classList.contains('on')) ouvrant.fin();
      if (ouvrantC && !ins.classList.contains('on')) ouvrantC.fin();   /* de même pour la carte gravée */
      if (ouvrantCi && !ins.classList.contains('on')) ouvrantCi.fin();   /* et pour la carte du ciel */
      if (visible()) { majRuban(false); majForme(); var p = pos; if (!cartes.length || !cartes[0].offsetWidth) { batir(); } pos = p; peindre(false); } })
      .observe(ins, { attributes:true, attributeFilter:['class'] });
    majForme(); majRuban(false); charger();

    /* La tuile de la carte photo ne se charge pas (fichier retiré, réseau coupé) : la carte s'en
       va. Elle est au centre de « Tous » au démarrage, et attente.js attend une image au centre
       pour lever son voile : une carte vide le retiendrait jusqu'à son échéance, qui accuse alors
       le réseau. Sans épreuve, la carte reste, en tuile seule. */
    /* 15/10 : généralisée à la carte gravée (même règle : sa tuile manque, elle s'en va avec sa pastille) */
    /* 15/10 (ciel) : la pastille « Un lieu » (mt-carte) est partagée par la carte et le ciel ; elle ne
       s'en va qu'avec la dernière des deux. Sans ciel, c'est exactement la règle d'avant. */
    function retirerVedette(V){
      var i = mods.indexOf(V); if (i < 0) return;
      mods.splice(i, 1);
      var cat = V === CIEL ? 'mt-carte' : V.id;
      var reste = cat === 'mt-carte' && [CARTE, CIEL].some(function(x){ return x && x !== V && mods.indexOf(x) >= 0; });
      var b = reste ? null : ruban.querySelector('.mts-cat[data-c="' + cat + '"]'); if (b) b.parentNode.removeChild(b);
      if (!reste && etat.cat === cat) etat.cat = 'tous';
      var garde = courant !== V ? courant : null;
      majRuban(false); charger();
      var j = garde ? liste.indexOf(garde) : -1; if (j > 0) { pos = j; peindre(false); bouts(); fiche(garde, true); planifier(); }
    }
    if (PHOTO) charge(PHOTO.t).then(function(s){ if (!s) retirerVedette(PHOTO); });
    /* la carte n'est au centre que sans photo : sinon on vérifie d'abord la petite image, celle que
       la première voisine charge de toute façon (aucun octet de plus sous le voile), puis la grande
       une fois le premier écran levé (affiner) */
    var verifCarte = CARTE ? charge(PHOTO ? CARTE.v : CARTE.t).then(function(s){ if (!s) retirerVedette(CARTE); return s; }) : null;
    /* le ciel (15/10) : même règle ; il n'est au centre que sans photo ni carte */
    var verifCiel = CIEL ? charge(PHOTO || CARTE ? CIEL.v : CIEL.t).then(function(s){ if (!s) retirerVedette(CIEL); return s; }) : null;

    /* Le premier écran est levé (la tomette du centre est décodée, ou n'a pas pu l'être) : le
       reste peut venir. Images nettes des premières voisines, épreuve de la carte photo, vignettes
       de la fiche photo, puis la file d'avance. Filet de 8 s si l'image du centre traîne.
       Relecture du 15/10 : avec une carte gravée, on attend d'abord le verdict sur sa petite image
       (déjà en route avec le premier écran, elle arrive en même temps que le centre), 1,5 s au
       plus. Sans lui, une carte dont les visuels manquent (thème publié avant le dépôt des
       fichiers) faisait encore demander sa grande tuile, son plan et l'exemple : 3 erreurs 404 et
       17 Ko pour rien à chaque visite. Sans carte gravée, rien ne change. */
    var affinage = false;
    function affiner(){
      if (affinage) return; affinage = true;
      /* avec le ciel (15/10), on attend les deux verdicts, toujours 1,5 s au plus ; sans ciel, rien ne change */
      var verdict = verifCiel ? Promise.all([verifCarte, verifCiel]) : verifCarte;
      if (!verdict) { affinerSuite(); return; }
      var fait = false, suite = function(){ if (fait) return; fait = true; affinerSuite(); };
      verdict.then(suite, suite); setTimeout(suite, 1500);
    }
    function affinerSuite(){
      ouvert = true;
      if (PHOTO && PHOTO.pm && mods.indexOf(PHOTO) >= 0) charge(PHOTO.pm).then(function(s){ if (s) return;
        PHOTO.duo = false; PHOTO.ph = PHOTO.ph.filter(function(u){ return u !== PHOTO.pm; });
        if (courant === PHOTO) { courant = null; fiche(PHOTO, true); } });
      /* la carte gravée : grande tuile absente → elle s'en va ; plan papier absent → tuile seule.
         Deux images que la première voisine charge de toute façon à ce moment : aucun octet de plus.
         (La gravure carreau, elle, n'est demandée que par les vignettes de sa fiche.) */
      if (CARTE && mods.indexOf(CARTE) >= 0) {
        /* l'exemple seulement si la grande tuile est bien là (relecture du 15/10) */
        charge(CARTE.t).then(function(s){ if (!s) retirerVedette(CARTE); else prechargerExemple(); });
        if (CARTE.pm) charge(CARTE.pm).then(function(s){ if (s) return;
          CARTE.duo = false; CARTE.ph = CARTE.ph.filter(function(u){ return u !== CARTE.pm; });
          if (courant === CARTE) { courant = null; fiche(CARTE, true); } });
      }
      /* la carte du ciel (15/10) : rien ici. Sa grande tuile, son épreuve et son exemple attendent
         qu'elle soit au centre ou première voisine (affinerCiel, appelée par images(), y compris par
         la boucle ci-dessous) : avec la photo et la carte, le ciel est 3ᵉ, et ces ~240 Ko n'ont rien
         à faire dans chaque visite (relecture du 15/10). Sa petite image est déjà vérifiée (verifCiel). */
      apres.splice(0).forEach(function(f){ f(); });
      cartes.forEach(function(c, i){ var a = Math.abs(enroule(i, pos)); if (a <= 4.1) images(c, liste[i], a); });
      planifier();
    }
    /* le ciel devient le centre ou la première voisine (premier écran levé) : sa grande tuile, puis
       son exemple ; grande tuile absente → il s'en va, comme la carte. Épreuve « ciel imprimé »
       absente → médaillon seul. Une seule fois. */
    var cielAffine = false;
    function affinerCiel(){
      if (cielAffine || !CIEL || mods.indexOf(CIEL) < 0) return; cielAffine = true;
      charge(CIEL.t).then(function(s){ if (!s) retirerVedette(CIEL); else prechargerExempleCiel(); });
      if (CIEL.pm) charge(CIEL.pm).then(function(s){ if (s) return;
        CIEL.duo = false; CIEL.ph = CIEL.ph.filter(function(u){ return u !== CIEL.pm; });
        if (courant === CIEL) { courant = null; fiche(CIEL, true); } });
    }
    (liste.length ? imageDe(liste[0], true).then(charge) : Promise.resolve()).then(affiner, affiner);
    setTimeout(affiner, 8000);
    fenetreDeDessin();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ majRuban(false); majForme(); });
    /* une invitation, une fois : le ruban glisse un peu puis revient */
    if (!reduit) setTimeout(function(){ if (ruban.scrollWidth <= ruban.clientWidth + 4) return; rd.classList.add('mts-appel');
      ruban.scrollTo({ left:Math.min(110, ruban.scrollWidth - ruban.clientWidth) }); setTimeout(function(){ ruban.scrollTo({ left:0 }); }, 650); }, 1100);
  }

  /* ---------- fenêtre de dessin pour l'admin (01/10/2026) ----------
     L'admin ouvre cette page avec ?mtsel-rendu=1 dans une petite fenêtre et lui
     demande, par messages, de dessiner des modèles avec le moteur du site.
     Seuls les messages venant de admin.mytomette.fr sont écoutés ; la réponse
     ne contient qu'une image du modèle public demandé. */
  function fenetreDeDessin(){
    var ADMIN = 'https://admin.mytomette.fr';
    if (!/[?&]mtsel-rendu=1(&|$)/.test(location.search) || !window.opener) return;
    var C = window.__MT_CORE__, file = Promise.resolve();
    function attente(ms){ return new Promise(function(ok){ setTimeout(ok, ms); }); }
    function png(){ return new Promise(function(ok){ try { C.renderPNG(null, function(v){ ok(typeof v === 'string' ? v : ''); }); } catch (e) { ok(''); } }); }
    function polices(){ return (document.fonts && document.fonts.ready) ? document.fonts.ready.catch(function(){}) : Promise.resolve(); }

    /* 14/10 : LE GUIDE DES GESTES DESSINAIT LA PREMIÈRE IMAGE. Le premier loadTemplate de la page
       passe par goEditor(), qui ouvre une fois la feuille d'aide ; le guide animé prend sa place
       (mt-editeur-tuto.js jusqu'à 760 px, donc dans cette fenêtre de 460 px, mt-editeur-tuto-bureau.js
       au-delà) et fait grandir, pivoter puis glisser la première gravure en pilotant le moteur,
       pendant 18 s. « Merci maîtresse — La classe avec vous » est ainsi sortie penchée, sur
       « Maîtresse Julie » : l'image était prise en plein acte « Tournez ».
       Ici seulement : ce premier chargement ouvre l'aide, on passe le guide par son propre bouton
       (il rend chaque valeur empruntée), puis on RECHARGE le modèle avant de dessiner. Et une image
       n'est acceptée que sans voile de guide, avec des gravures restées celles du modèle
       (rot, size, x, y) avant ET après le dessin ; sinon on recharge. Pour les clients, rien ne
       change : le guide reste proposé au premier passage. */
    var VOILES = '#mtwTuto,#mtwbTuto', guide = null;
    function voile(){ return document.querySelector(VOILES); }
    function passer(v){
      var b = v.querySelector('.mtw-tu-passer,.mtwb-passer');
      if (b) { try { b.click(); } catch (e) {} return; }
      try { document.dispatchEvent(new KeyboardEvent('keydown', { key:'Escape', bubbles:true })); } catch (e) {}   /* les deux guides écoutent Échap */
    }
    /* Le guide se pose ~0,9 s (téléphone) ou ~1,3 s (bureau) après le chargement. Feuille d'aide
       encore ouverte quand on la regarde : aucun guide ne l'a prise (animations réduites…), on la
       ferme comme eux. Ni aide ni guide au bout de 4 s : la page les avait déjà montrés. */
    function sansGuide(){
      return new Promise(function(ok){
        var t0 = Date.now(), aide = 0, coupe = 0;
        (function guetter(){
          var v = voile(), ov = document.getElementById('sheetOv'), mtn = Date.now();
          if (v) {
            if (!coupe || mtn - coupe > 800) { passer(v); coupe = mtn; }
            if (mtn - t0 > 15000) { try { v.remove(); } catch (e) {} ok(); return; }
            setTimeout(guetter, 60); return;
          }
          if (coupe) { ok(); return; }
          if (ov && ov.dataset.kind === 'help') {
            if (ov.classList.contains('on')) { ov.classList.remove('on', 'peek'); ok(); return; }
            if (!aide) aide = mtn;
            if (mtn - aide > 3000) { ok(); return; }
          } else if (mtn - t0 > 4000) { ok(); return; }
          setTimeout(guetter, 60);
        })();
      });
    }
    function empreinte(){ return JSON.stringify(((C.state && C.state.els) || []).map(function(e){ return [e.id, +e.rot || 0, e.size, e.x, e.y, !!e.manual]; })); }
    function charger(t){ C.loadTemplate(t); try { C.deselect && C.deselect(); } catch (e) {} return empreinte(); }

    function rendre(id){
      var t = (C.TEMPLATES || []).filter(function(x){ return x.id === id; })[0];
      if (!t) return Promise.resolve({ mtsel:'erreur', id:id, msg:'absent du catalogue public' });
      if (!guide) { C.loadTemplate(t); guide = sansGuide(); }
      /* 01/10 : une image dessinée avant l'arrivée d'une police de gravure sort avec un texte
         mal dimensionné (« Sicile » trop grand), et deux dessins trop rapides peuvent être
         identiques ET faux. On exige : polices MTE_ chargées, deux dessins identiques à une
         seconde d'écart, et au moins 4 s écoulées (12 essais au plus). */
      var ref = '', t0 = 0, prec = '', essai = 0, recharges = 0;
      /* 14/10 : seule une police EN COURS de chargement fait attendre. MTE_Symboles reste
         « unloaded » tant qu'aucun symbole ne la demande : la compter rendait ce test toujours
         faux, et chaque image prenait ses 12 dessins (13 s), quoi qu'il arrive. */
      function mtePretes(){ var ok = true; if (document.fonts && document.fonts.forEach) document.fonts.forEach(function(f){ if (/^MTE_/.test(String(f.family).replace(/['"]/g, '')) && f.status === 'loading') ok = false; }); return ok; }
      function intact(){ return !voile() && empreinte() === ref; }
      function partir(){ ref = charger(t); t0 = Date.now(); prec = ''; essai = 0; return attente(1200).then(boucle); }
      function boucle(){
        var avant = intact();
        return png().then(function(u){ return polices().then(function(){ return u; }); }).then(function(u){
          if (!avant || !intact()) {
            if (++recharges > 3) return { faux:true };
            var v = voile(); if (v) passer(v);
            return attente(v ? 600 : 0).then(partir);
          }
          if (u && u === prec && mtePretes() && Date.now() - t0 > 4000) return u;
          prec = u; if (++essai >= 12) return u;
          return attente(1000).then(boucle);
        });
      }
      return guide.then(partir)
        .then(function(u){ return (u && u.faux) ? { mtsel:'erreur', id:id, msg:'gravure dérangée pendant le dessin' }
          : u ? { mtsel:'image', id:id, png:u } : { mtsel:'erreur', id:id, msg:'rendu vide' }; });
    }
    window.addEventListener('message', function(ev){
      if (ev.origin !== ADMIN || ev.source !== window.opener || !ev.data || typeof ev.data !== 'object') return;
      if (ev.data.mtsel === 'fermer') { window.close(); return; }
      if (ev.data.mtsel !== 'rendre' || typeof ev.data.id !== 'string') return;
      var id = ev.data.id;
      file = file.then(function(){ return rendre(id); }).then(function(r){ window.opener.postMessage(r, ADMIN); })
        .catch(function(e){ window.opener.postMessage({ mtsel:'erreur', id:id, msg:String(e && e.message || e) }, ADMIN); });
    });
    window.opener.postMessage({ mtsel:'pret', modeles:(C.TEMPLATES || []).length }, ADMIN);
  }
})();
